import gsap from "gsap";
import { observer } from "./shared";

const
section_2 = document.getElementById("section-2");

observer.observe(section_2);
